/**
 * RevenueCat inbound presenter.
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  REVENUECAT_EVENT_CATEGORIES,
  REVENUECAT_EVENT_METADATA,
} from './supported-events'

export const REVENUECAT_SIGNING_SECRET_MIN_LENGTH = 16

export const revenuecatInboundPresenter: InboundProviderPresenter = {
  providerId: 'revenuecat',
  displayName: 'RevenueCat',
  categories: REVENUECAT_EVENT_CATEGORIES,
  events: REVENUECAT_EVENT_METADATA,
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `revenuecat:${orgId}:${brandId}:${eventType}`
  },
}
